<template>
    <div>
      
        <!-- header start here -->
        <div class="">
        <div>
            <b-row class="custom-header-outer">
                        <b-col md="2"><strong class="custom-basealign">Audit Status Details</strong></b-col>
                        <b-col md="4">
                          <b-form-group label="Select Hub" :label-cols="3">
                            <v-select 
    
      v-model="selectedhub" 
      @input="dashboardList(selectedhub)" 
      :options="hubItems" 
      placeholder="-- Select Hub --" 
      label="label" 
      :reduce="hub => hub.key"
      @blur="onDropdownClose">  <!-- Using @blur to detect dropdown close -->
    </v-select>
                          </b-form-group>
                        </b-col>
  
                <b-col md="3">
                  <b-form-group label="Select Date" :label-cols="4">
                  <b-form-select v-model="selectFromDate" @change="dashboardList(selectFromDate)">
                    <option value="">-- Select Date --</option>
                    <option :value="seleteDate.dates" v-for="seleteDate in dateAgainstHub" :key="seleteDate.audit_id">
                      {{ seleteDate.dates }}
                    </option>
                  </b-form-select>
                  </b-form-group>
                </b-col>
                <b-col md="3" class="custom-download-align">
                  <b-button variant="primary" @click="downloadUrl('main-dashobard')">Download</b-button>
                </b-col>
              <!-- <b-col md="3" class="text-right"><strong>Download</strong></b-col>               -->
            </b-row>
          </div>
        </div>
          <!-- header end here -->
      <!-- Loop through the hubs data and render a card for each item -->
      <div  class="text-center">
        <div v-if="isLoading" class="loader-overlay">
      <i class="fa fa-spinner fa-spin"></i> Loading...
    </div>
             
     <div class="custom-card-outer" v-if="hubs.length > 0">
      <b-card v-for="(hub, index) in hubs" :key="hub.hub_id" class="mb-3 custom-bg-color">
        <template #header>
          <div class="d-flex justify-content-between align-items-center">
            <span class="span-border"><strong># {{ hub.hub_id }}</strong></span>
            <span class="span-border"><strong>{{ hub.hub_title }}</strong></span>
            <span><strong>Last Audit:-{{ hub.last_audit }}</strong></span>
            <span><strong><i
      class="fas fa-download custom-icon"
      @click="downloadUrl('hub-details', hub.hub_id)"
      style="cursor: pointer; font-size: 1.0rem;"
    ></i></strong></span>
            
            <!-- Button to toggle the collapse for each hub -->
            <i
    :class="collapseVisible[hub.hub_id + '-' + index] ? 'fa fa-chevron-up' : 'fa fa-chevron-down'"
    @click="toggleCollapse(hub.hub_id + '-' + index)"
    style="cursor: pointer; font-size: 1.0rem;"
    class="toggle-icon"
  ></i>
          </div>
        </template>
        <!-- First level collapsible content for each hub -->
        <b-collapse v-model="collapseVisible[hub.hub_id + '-' + index]" class="mt-2 custom-inner-outer">
            <!-- Loop through the ZonewiseCount data and create a card for each -->
             <!-- {{ hub.ZonewiseCount }} -->
             <div v-if="ZonewiseCount.length === 0" class="text-center">
             <span v-if="isLoading">
                <span colspan="10">
                  <i class="fa fa-spinner fa-spin"></i> Loading...
                </span>
              </span>
            </div>  
            <div v-for="(zone, zoneIndex) in ZonewiseCount" :key="zone.audit_id">
              <b-card class="mt-3">
                <template #header>
                  <div class="d-flex justify-content-between align-items-center">
                    <span><strong>Audit Scanned : - {{ zone.audit_scanned }}</strong></span>
                    <span><strong>Total Scanned : - {{ zone.total_records }}</strong></span>
                    <span><strong><i
      class="fas fa-download custom-icon"
      @click="downloadUrl('audit-details', zone.hub_id, zone.audit_id)"
      style="cursor: pointer; font-size: 1.0rem;"
    ></i></strong></span>
    <i
    :class="secondLevelCollapseVisible[zone.audit_scanned + '-' + zoneIndex] ? 'fa fa-chevron-up' : 'fa fa-chevron-down'"
    @click="toggleSecondLevelCollapse(zone.audit_scanned + '-' + zoneIndex, zone.hub_id, zone.audit_id)"
    style="cursor: pointer; font-size: 1.0rem;"
    class="toggle-icon"
  ></i>
  
                    <!-- </button> -->
                  </div>
                </template>
  
                <!-- Second level collapsible content for zone-wise data -->
                <b-collapse v-model="secondLevelCollapseVisible[zone.audit_scanned + '-' + zoneIndex]" class="mt-2 custom-inner-before-table">
                  <!-- <b-card-body> -->
                    <div v-if="auditStatusDetails.length === 0" class="text-center">
             <span v-if="isLoading">
                <span colspan="10">
                  <i class="fa fa-spinner fa-spin"></i> Loading...
                </span>
              </span>
            </div>  
                    <!-- Display audit status cards -->
                    <div v-if="auditStatusDetails.length > 0">
                  <b-row class="d-flex justify-content-between align-items-center custom-inner-outer">
                    <b-col>
                        <b-card class="custom-padding-card">
                          Audit Start : {{ auditStatusDetails[0].audit_start }}
                        </b-card>
                    </b-col>
                    <b-col>
                        <b-card class="custom-padding-card" v-if="auditStatusDetails[0].audit_end_date === null">
                          Audit Status : {{ auditStatusDetails[0].status }}
                      </b-card>
                    </b-col>
                    <b-col v-if="auditStatusDetails[0].audit_end_date !== null">
                        <b-card class="custom-padding-card">
                          Audit End : {{ auditStatusDetails[0].audit_end_date }}
                      </b-card>
                    </b-col>
                    <span v-if="auditStatusDetails[0].audit_end_date === null">
                    <b-col>
                      <b-card class="custom-card-border">
                        <!-- @click="endAuditScanned(auditStatusDetails[0].audit_id)"  -->
                        <b-button class="custom-bg-btn" @click="transporterMasterLog(auditStatusDetails[0].audit_id)">End Audit Scanning</b-button>
                    </b-card>
                  </b-col>
                </span>
                  </b-row>
                  
                      <div v-for="(status, statusIndex) in auditStatusDetails" :key="status.helper_id" class="custom-outer-card">
                        <b-card>
                          <template #header>
                            <b-row>
                              <b-col class="col-10">
                                <b-row align-h="between">
                                  <b-col cols="4">Audit Scanned: {{ status.audit_scanned }}</b-col>
                                  <b-col cols="4">Scanned By:  {{ status.scanned_by }}</b-col>
                                </b-row>
                                <b-row align-h="between">
                                  <b-col cols="4">Total Record - {{ status.total_records }}</b-col>
                                  <b-col cols="4">EMP ID - {{ status.emp_id }}</b-col>
                                </b-row>
                              </b-col>
                              <b-col class="col-2 custom-align-btn">
                                <!-- <b-button > -->
                                  <i 
    @click="toggleTableData(status.emp_id, status)" 
    :class="dummyDataVisible[status.emp_id] && dummyDataVisible[status.emp_id].isVisible ? 'fa fa-chevron-up' : 'fa fa-chevron-down'" 
    style="cursor: pointer; font-size: 1.0rem;"
    class="toggle-icon">
  </i>
                              <!-- </b-button> -->
                              </b-col>
                            </b-row>
                          </template>
  
                          <!-- <b-card-body> -->
                            <!-- Collapsible content for dummy data -->
                            <b-collapse :visible="dummyDataVisible[status.emp_id] && dummyDataVisible[status.emp_id].isVisible" class="mt-2">
                              <div class="custom-outer-card">
                          <!-- <b-card> -->
                              <b-row class="table-card-outer" align-h="between">
                                          <b-col cols="3">
                    <b-form-group label-cols-sm="3" label="Mps No." class="mb-0">
                    <b-input-group>
                      <b-form-input v-model="mps_filter" placeholder="Type to Search" @input="filterDataOnSearch(status.emp_id, status)"></b-form-input>
                    </b-input-group>
                  </b-form-group>
                                          </b-col>
                                          <b-col cols="3">
                                              <b-form-group label="Zone" :label-cols="4">
                    <b-form-select v-model="selectedzone" @change="getAlltableData(status.emp_id, status)">
                      <option value="">-- Select Zone --</option> <!-- Empty option to indicate default "Select Hub" -->
                      <option :value="zone_title" v-for="zone_title in zoneItems" :key="zone_title">
                        {{ zone_title.zone_title }}
                      </option>
                    </b-form-select>
                    </b-form-group>
                              </b-col>
  
                                <b-col cols="3">
                                  <b-form-group label="Status" :label-cols="4">
                      <b-form-select v-model="selectedawb_status" @change="getAlltableData(status.emp_id, status)">
                        <option value="">-- Select Status --</option> <!-- Empty option to indicate default "Select Hub" -->
                        <option :value="status" v-for="status in allStatus" :key="status.awb_status">
                          {{ status.awb_status }}
                        </option>
                      </b-form-select>
                    </b-form-group>
                                  </b-col>
                                <b-col cols="3" class="text-right">
  
                                  <b-button variant="primary" @click="downloadUrl(status, 'table-data')">Download</b-button>
  
                                </b-col>              
                              </b-row>
                            <!-- </b-card> -->
                          </div>
                              <!-- <b-card class="mt-2 custom-outer-card"> -->
                                <div class="custom-outer-card">
                                  <div class="text-right mt-3">
                                    <span class="custom-padding-card" v-if="dummyDataVisible[status.emp_id] && dummyDataVisible[status.emp_id].data.length > 0 && tableData === false">
                                      <strong>Total Records : <strong class="text-danger">{{ dummyDataVisible[status.emp_id] && dummyDataVisible[status.emp_id].data.length }}</strong></strong>
                                    </span>
                                    <span class="custom-padding-card" v-if="tableData === true">
                                      Total Records : <strong class="text-danger">0</strong>
                                    </span>
                                  </div>
    <div class="table-responsive">
      <table class="table custom-outer-card">
        <thead>
          <tr v-if="isLoading">
        <td colspan="10" class="text-center">
          <i class="fa fa-spinner fa-spin"></i> Loading...
        </td>
      </tr>
          <tr>
            <th>Sr No</th>
            <th>Audit Scanned Zone</th>
            <th>System Scanned Zone</th>
            <th>MPS No</th>
            <th>AWB No</th>
            <th>BOX No</th>
            <th>Load ID</th>
            <th>Current Status</th>
            <th>Current Status Date/Time</th>
            <th>Scanned By</th>
          </tr>
        </thead>
        <tbody>
          <tr 
              v-for="(item, index) in (dummyDataVisible[status.emp_id] && dummyDataVisible[status.emp_id].data || [])" 
            :key="item.emp_id"
            :class="{
              'highlight-row': item.audit_scanned_zone !== item.system_scanned_zone,  // Apply highlight if mismatch
              'highlight-red': item.current_status !== 'ZoneInScan'  // Red highlight for non-ZoneInScan
            }"
            v-if="!tableData"
          >
            <td>{{ index + 1 }}</td>
            <td>{{ item.audit_scanned_zone }}</td>
            <td>{{ item.system_scanned_zone }}</td>
            <td>{{ item.mps_no }}</td>
            <td>{{ item.awb_no }}</td>
            <td>{{ item.box_no }}</td>
            <td>{{ item.load_id }}</td>
            <td>{{ item.current_status }}</td>
            <td>{{ item.current_status_datetime }}</td>
            <td>{{ item.scanned_by }}</td>
          </tr>
          <tr v-if="tableData === true">
            <td colspan="10">No Record Found</td>
          </tr>
        </tbody>
      </table>
    </div>
  
  
  
                                  </div>
                              <!-- </b-card> -->
                            </b-collapse>
                          <!-- </b-card-body> -->
                        </b-card>
                      </div>
                    </div>
                  <!-- </b-card-body> -->
                </b-collapse>
              </b-card>
            </div>
        </b-collapse>
      </b-card>
      <b-row>
          <!-- <b-col sm="12" class="text-right">
            <p style="margin-top: 15px;"> <b>Total Records :<span style="color:red;"> {{totalRows}}</span></b> </p>
          </b-col>  -->
          <b-col md="12" class="my-1">
            <paginate       
              :page-count="noofpages"
              :page-range="10"
              :margin-pages="2"
              :click-handler="clickCallback"
              :prev-text="'Prev'"
              :next-text="'Next'"
              :container-class="'pagination'"
              :page-class="'page-item'">
            </paginate>
          </b-col>     
          
        </b-row>  
    </div>
    <div v-if="hubs.length === 0" class="text-center">
      No Record Found
    </div>
  </div> 
  
  
    <b-modal ref="transporterLogModal" title="End Audit Scan" hide-footer size="lg">
    <!-- Loader Section -->
    <div v-if="loader" id="listloader" class="text-center">
      <div class="listloader"></div>
      <br/>
      <span class="loading" style="color:#fff;">Loading...</span>
    </div>
  
    <!-- Main Content Section -->
    <div v-else>
      <p class="text-center">Are you sure to End Audit Task?</p>
  
      <!-- Action Buttons -->
      <div class="text-center">
        <b-button variant="secondary" @click="endAuditScanned" class="mx-2">Yes</b-button>
        <b-button variant="secondary" @click="closeAuditScanned" class="mx-2">No</b-button>
      </div>
    </div>
  </b-modal>
  
    </div>
  </template>
  <script>
  import CONSTANTS from '@/utils/constants'
  import Vue from 'vue'
  
  export default {
  data() {
    return {
      hubs: [],
      collapseVisible: {},
      secondLevelCollapseVisible: {},  // Track second level collapses (for Zonewise records)
      auditStatusDetails: [],
      dummyDataVisible: {},
      
  
    valueWH:[],
    fieldWH:{ text: 'name', value: 'id' },
    optionsWH:[],
    WHData:[],
    showSelectAll : true,
    selectFromDate : null,
    selectToDate:  null,
    hubItems:[],
    selectedhub:'',
    zoneItems: [],
    selectedzone: '',
    selectedawb_status: '',
    allStatus: [],
    ZonewiseCount: [],
    dateAgainstHub: [],
    loadurl :'',
    mps_filter: '',
    noofpages:'',
    pageNum:1,
    totalRows: 0,
    assigntotalRows:0,
    activeAndAuditScannedBtn: false,
    filterList: [],
    isLoading: false, // Loader state
    tableData: false,
    };
  },
  created() {
    this.hubListing();
    this.dashboardList(this.pageNum);
    this.zoneListing();
    this.scanStatusListing();
  },
  
  methods: {
    toggleTableData(emp_id, status) {
      this.tableData = false;
      this.mps_filter = '';
    // If the table is already open, close it and clear data
    if(this.selectedzone && this.selectedzone.zone_title) {
        this.selectedzone = '';
    }
    if(this.selectedawb_status && this.selectedawb_status.awb_status) {
        this.selectedawb_status = '';
    }
    
  
    if (this.dummyDataVisible[emp_id] && this.dummyDataVisible[emp_id].isVisible) {
      // Close the table and clear data    
      this.$set(this.dummyDataVisible, emp_id, { isVisible: false, data: [] });
    } else {
      // If emp_id does not exist, initialize it
      if (!this.dummyDataVisible[emp_id]) {
        this.$set(this.dummyDataVisible, emp_id, { isVisible: false, data: [] });
      }
  
      // Close all other tables by setting them to isVisible: false and clearing their data
      Object.keys(this.dummyDataVisible).forEach(id => {
        if (id !== emp_id) {
          this.$set(this.dummyDataVisible, id, { ...this.dummyDataVisible[id], isVisible: false, data: [] });
        }
      });
  
      // Open the clicked emp_id's table
      this.$set(this.dummyDataVisible, emp_id, { ...this.dummyDataVisible[emp_id], isVisible: true });
      
      // Fetch new data if it's not already available
      if (this.dummyDataVisible[emp_id].data.length === 0) {
        this.getAlltableData(emp_id, status); // Fetch new data
      }
    }
  },
  
  
  //   toggleTableData(emp_id, status) {
  //   // Clear data for all tables before opening a new one
  //   Object.keys(this.dummyDataVisible).forEach(id => {
  //     if (id !== emp_id) {
  //       this.$set(this.dummyDataVisible, id, { ...this.dummyDataVisible[id], data: [] }); // Clear data for all other tables
  //     }
  //   });
  
  //   // If emp_id does not exist, initialize it
  //   if (!this.dummyDataVisible[emp_id]) {
  //     this.$set(this.dummyDataVisible, emp_id, { isVisible: false, data: [] }); // Default state
  //   }
  
  //   // If the current emp_id is already open, toggle it to close
  //   if (this.dummyDataVisible[emp_id].isVisible) {
  //     this.$set(this.dummyDataVisible, emp_id, { ...this.dummyDataVisible[emp_id], isVisible: false }); // Close the table
  //   } else {
  //     // Close all other tables by setting them to isVisible: false
  //     Object.keys(this.dummyDataVisible).forEach(id => {
  //       if (id !== emp_id) {
  //         this.$set(this.dummyDataVisible, id, { ...this.dummyDataVisible[id], isVisible: false });
  //       }
  //     });
  
  //     // Open the clicked emp_id's table
  //     this.$set(this.dummyDataVisible, emp_id, { ...this.dummyDataVisible[emp_id], isVisible: true });
  //   }
  
  //   // Fetch new data if it's not already available
  //   if (this.dummyDataVisible[emp_id].data.length === 0) {
  //     this.getAlltableData(emp_id, status); // Fetch new data
  //   }
  // },
  
  
  
  toggleCollapse(hub_id_with_index) {
    // this.selectedawb_status='';
    // If the collapse is already expanded, collapse it to false
    if (this.collapseVisible[hub_id_with_index]) {
      // Close the current hub and clear the data when collapsing
      this.$set(this.collapseVisible, hub_id_with_index, false);
      this.clearAuditData();
  
      // Reset all second-level collapses to false (closed state)
      // Object.keys(this.secondLevelCollapseVisible).forEach(key => {
      //   this.$set(this.secondLevelCollapseVisible, key, false);
      // });
      Object.keys(this.secondLevelCollapseVisible).forEach(key => {
    // Close all collapses except the one that was clicked
    if (key !== collapseKey) {
      this.$set(this.secondLevelCollapseVisible, key, false);
    }
  });
  
    } else {
      // Close all other collapses first (set them to false)
      for (let key in this.collapseVisible) {
        this.$set(this.collapseVisible, key, false);
      }
  
      // Then toggle the selected collapse to true
      this.$set(this.collapseVisible, hub_id_with_index, true);
      // Fetch the data when expanding the selected hub
      this.getAllAuditsAgainstHub(hub_id_with_index);
  
      // Ensure that all second-level collapses are reset to false (closed state)
      // Object.keys(this.secondLevelCollapseVisible).forEach(key => {
      //   this.$set(this.secondLevelCollapseVisible, key, false);
      // });
      Object.keys(this.secondLevelCollapseVisible).forEach(key => {
    // Close all collapses except the one that was clicked
    if (key !== collapseKey) {
      this.$set(this.secondLevelCollapseVisible, key, false);
    }
  });
  
    }
  },
  
  
  clearAuditData() {
    // Clear or reset the audit data when collapse is hidden
    this.ZonewiseCount = []; // Or whatever default value is needed to clear the data
  },
  
  
  toggleSecondLevelCollapse(collapseKey, hub_id, audit_id) {
    // Get audit details
    this.getAuditStatusDetails(hub_id, audit_id);
  
    // If the collapse is currently open, close it and clear the data
    if (this.secondLevelCollapseVisible[collapseKey]) {
      this.$set(this.secondLevelCollapseVisible, collapseKey, false);  // Close the collapse
      this.clearAuditStatusData();  // Clear the data
    } else {
      // Close all other collapses except the one that was clicked
      for (let key in this.secondLevelCollapseVisible) {
        if (key !== collapseKey) {
          this.$set(this.secondLevelCollapseVisible, key, false); // Close other collapses
        }
      }
  
      // Open the clicked collapse
      this.$set(this.secondLevelCollapseVisible, collapseKey, true);  // Open the collapse
  
      // Fetch audit status details
    }
  },
  
  // toggleSecondLevelCollapse(audit_scanned, hub_id, audit_id) {
  //   this.getAuditStatusDetails(hub_id, audit_id);
  //   // If the collapse is currently open, close it and clear the data
  //   if (this.secondLevelCollapseVisible[audit_scanned]) {
  //     this.$set(this.secondLevelCollapseVisible, audit_scanned, false);  // Close the collapse
  //     this.clearAuditStatusData();  // Clear the data
  //     // this.toggleTableData()
  //   } else {
  //     // Close all other collapses except the one that was clicked
  //     for (let key in this.secondLevelCollapseVisible) {
  //       if (key !== audit_scanned) {
  //         this.$set(this.secondLevelCollapseVisible, key, false); // Close other collapses
  //       }
  //     }
  
  //     // Toggle the clicked collapse visibility (open/close)
  //     this.$set(this.secondLevelCollapseVisible, audit_scanned, true);  // Open the collapse
  
  //     // Fetch audit status details
  //   }
  // },
  
  clearAuditStatusData() {
    // Clear or reset the audit status data when collapse is hidden
    this.auditStatusDetails = []; // Or set it to the appropriate default value to clear the data
  },
  
  
  
    // Fetch audit status details
    getAuditStatusDetails(hub_id, audit_id) {
      const obj = {
        hubid: hub_id,
        audit_id: audit_id
      };
      this.isLoading=true;
      this.$http.post(`${CONSTANTS.MIGRATION_API_URL}/getAuditStatusDetails`, obj)
        .then(result => {
          document.getElementById("overlay").style.display = "none";
          if (result.body.returnmsg === "Successful") {
            this.isLoading=false;
            this.auditStatusDetails = result.body.returnvalue; // Set the fetched audit status data
          } else {
            this.auditStatusDetails = []; // Clear if no data
          }
        })
        .catch(ex => {
          this.isLoading=false;
          console.log("error", ex);
          this.auditStatusDetails = []; // Clear in case of error
        });
    },
  
    clickCallback(pageNum){
          // alert("ok")
          // this.listingpageno = pageNum;
          // console.log("pageNum",this.listingpageno)\
          console.log(pageNum, 'pageNumpageNum')
  
          this.dashboardList(pageNum);
        },
  
    // Fetch the initial dashboard data
    dashboardList(pageNo) {
      console.log('okkkk12333',)
      var userdata = localStorage.getItem("userData");
      var userInfo = JSON.parse(userdata);
      if (this.selectedhub !== '' && this.selectedhub && this.selectedhub.key) {
        // this.selectedhub = userInfo.hub_id.toString();
        this.getAllDatesAgainstHub(this.selectedhub.key)
      }
      if (this.selectFromDate === 'All Record') {
        this.selectFromDate = ''
      }
      if (pageNo == undefined) {
        this.selectFromDate = null;
        pageNo = 1
      }
      let hubid;
  
  // Check if selectedhub is valid before trying to access or assign its properties
  if (this.selectedhub && this.selectedhub.key) {
    hubid = this.selectedhub.key.toString();
  } else if (userInfo.user_type === 1) {
    hubid = '';
  } else {
    // Only assign to this.selectedhub.key if this.selectedhub is not null or undefined
    if (this.selectedhub) {
      console.log(userInfo, 'userInfouserInfouserInfo22')
  
      if (userInfo.user_type === 2) {
        hubid = userInfo.hub_id.toString();
      } else {
        this.selectedhub.key = userInfo.hub_id.toString();
        hubid = this.selectedhub.key;
      }
      
    } else {
      // Handle the case when this.selectedhub is null or undefined
      // For example, you could set a default value or throw an error
      hubid = userInfo.hub_id.toString(); // Or handle it in a way that makes sense for your app
    }
  }
      const obj = {
        // hubid: this.selectedhub && this.selectedhub.key ? this.selectedhub.key.toString() : userInfo.user_type === 1 ? '' : this.selectedhub.key = userInfo.hub_id.toString(),
        hubid: hubid,
        date: this.selectFromDate!=null ? this.selectFromDate : null,
        // pageno:this.selectedhub && this.selectedhub.key ? 1 : pageNo,
        pageno:this.pageNum ? this.pageNum : pageNo,
        limit: 10
      }
      
      this.$http.post(`${CONSTANTS.MIGRATION_API_URL}/getHubwiseAuditData`, obj)
        .then(result => {
          document.getElementById("overlay").style.display = "none";
          if (result.body.returnmsg === "Successful") {
            this.hubs = result.body.returnvalue;
            this.totalRows = result.body.totalcount;  
                  this.noofpages=parseInt(this.totalRows)/10;
                  this.noofpages=Math.ceil( this.noofpages);
          } else {
            this.hubs = [];
          }
        }).catch(ex => {
          console.log("error", ex);
        });
    },
  
    getAllDatesAgainstHub(hubid) {
      var userdata = localStorage.getItem("userData");
      var userInfo = JSON.parse(userdata);
      const obj={
        // sysusermasterid:`${userInfo.sysusermasterid}`,
        // usertype : `${userInfo.user_type}`,
        hubid : [hubid]
      }
      this.$http
            .post(
              `${ CONSTANTS.MIGRATION_API_URL}/getAllDatesForDropDown`,obj).then(result => {
                if (result.body.returnmsg === "Successful") {
                  if (result.body.returnvalue.length > 0) {
                    this.dateAgainstHub=[...result.body.returnvalue, {dates: "All Record", audit_id: 100021}];
                  } 
                  else {
                    this.dateAgainstHub=result.body.returnvalue;
                  }
                 
                 
                }else{
                  this.dateAgainstHub=[];
                }
              }).catch(ex => {
              console.log("error", ex);
            });
    },
  
     // Fetch the audits against a hub
     getAllAuditsAgainstHub(hub_id) {
      this.isLoading = true;
      const obj = {
        hubid: hub_id ? hub_id.split('-')[0] : ''
      };
      this.$http.post(`${CONSTANTS.MIGRATION_API_URL}/getAllAuditsAgainstHub`, obj)
        .then(result => {
          document.getElementById("overlay").style.display = "none";
          if (result.body.returnmsg === "Successful") {
              this.ZonewiseCount = result.body.returnvalue;  // Assign the fetched ZonewiseCount data
              this.isLoading = false;
          }
        })
        .catch(ex => {
          console.log("error", ex);
        });
    },
  
    filterDataOnSearch(emp_id, status) {
        this.getAlltableData(emp_id, status, this.mps_filter);
      },
  
      getAlltableData(emp_id, status, mps_filter = '') {
   
    console.log(status, 'statusstatusstatus')
    this.isLoading = true;
    let auditID = '';
    let empID = '';
    // Prepare the object for the API call
    console.log(this.filterList, 'this.filterListthis.filterListthis.filterList')
    if (status == undefined) {
      auditID = this.filterList[0].audit_id;
      empID = this.filterList[0].empi_id;
      // status.emp_id = this.filterList[0].emp_id
    }
    console.log(emp_id, 'emp_id');
    console.log(empID, 'empID');
    const obj = {
      audit_id: status ? status.audit_id: auditID,
      empi_id: status ? status.emp_id: empID,
      date: null,
      mpsno: '',
      zone: this.selectedzone ? this.selectedzone.zone_title : '',
      status: this.selectedawb_status ? this.selectedawb_status.awb_status : '',
    };
  
    // Simulate API call (replace with actual API)
    this.$http.post(`${CONSTANTS.MIGRATION_API_URL}/getAllAuditDetails`, obj)
      .then(result => {
        if (result.body.returnmsg === 'Successful') {
          this.isLoading = false;
          console.log("Clearing data for emp_id", emp_id);
          console.log("Setting new data for emp_id", emp_id, result.body.returnvalue);
  
          if (status == undefined) {
            console.log('aaaaaaaaaa123', empID);
            this.$set(this.dummyDataVisible, empID, { data: result.body.returnvalue, isVisible:true });
          } else{
            console.log(emp_id, 'aaaaaaaa22211090=>>>>>>>>>>>>', { data: result.body.returnvalue })
            this.tableData = false;
            this.$set(this.dummyDataVisible, emp_id, { data: result.body.returnvalue, isVisible:true });
          }
          this.filterList = result.body.returnvalue;
  
          // Optional: Apply filter if mps_filter is passed
          if (mps_filter) {
            if (status == undefined) {
              this.dummyDataVisible[empID].data = this.dummyDataVisible[empID].data.filter(item =>
              item.mps_no.toLowerCase().includes(mps_filter.toLowerCase())
            );
            } else {
              this.dummyDataVisible[emp_id].data = this.dummyDataVisible[emp_id].data.filter(item =>
              item.mps_no.toLowerCase().includes(mps_filter.toLowerCase())
            );
            }
            
          }
        } else {
          console.log('okkkkkkkkkkkkkkkkkkkkkkkkkkkk=>>>>>>>>>>>>>>>>>>>>')
          this.isLoading = false;
          this.tableData = true;
          // Reset data on failure
          if (status == undefined) {
            this.$set(this.dummyDataVisible, empID, { data: [], isVisible:true });
          } else{
            this.$set(this.dummyDataVisible, emp_id, { data: [], isVisible:true });
          }
        }
      })
      .catch(ex => {
        console.log("error", ex);
        this.isLoading = false;
        if (status == undefined) {
            this.$set(this.dummyDataVisible, empID, { data: [], isVisible:true });
          } else{
            this.$set(this.dummyDataVisible, emp_id, { data: [], isVisible:true });
          }
      });
  },
      
  
  hubListing(){
      var userdata = localStorage.getItem("userData");
      var userInfo = JSON.parse(userdata);
      const obj = {
          sysusermasterid: `${userInfo.sysusermasterid}`,
          usertype: `${userInfo.user_type}`,
      };
      if (userInfo.user_type === 2) {
          // You can modify this logic to choose a default value based on your use case
          // For example, setting it to the first hub in the list or a specific hub
          this.selectedhub = null; // Initialize or reset selectedhub if necessary
          
      }
  
      this.$http
          .post(`${CONSTANTS.MIGRATION_API_URL}/getAllHubListing`, obj)
          .then(result => {
              if (result.body.returnmsg === "Successful") {
                  const data = result.body.returnvalue.map(srData => ({
                      key: srData.hubid,
                      label: `${srData.hubname} - ${srData.hubid}`,
                  }));
                  this.hubItems = data;
                  
                  if (userInfo.user_type === 2 && this.hubItems.length > 0) {
                      // Set default selected hub if user_type === 2
                      this.selectedhub = this.hubItems[0].label; // This will select the first hub in the list
                      this.getAllDatesAgainstHub(this.hubItems[0].key)
                  }
              } else {
                  this.hubItems = [];
              }
          })
          .catch(ex => {
              console.log("error", ex);
          });
  },
  
  
      // zone listing start here
      zoneListing(){
      var userdata = localStorage.getItem("userData");
      var userInfo = JSON.parse(userdata);
      const obj={
        sysusermasterid:`${userInfo.sysusermasterid}`,
        usertype : `${userInfo.user_type}`,
      }
      this.$http
            .post(
              `${ CONSTANTS.MIGRATION_API_URL}/getAllZonesForDropdown`,obj).then(result => {
                if (result.body.returnmsg === "Successful") {
                 this.zoneItems=result.body.returnvalue;
                 
                 
                }else{
                  this.zoneItems=[];
                }
              }).catch(ex => {
              console.log("error", ex);
            });
      },
  
      // scan status listing start here
      scanStatusListing(){
      var userdata = localStorage.getItem("userData");
      var userInfo = JSON.parse(userdata);
      const obj={
        sysusermasterid:`${userInfo.sysusermasterid}`,
        usertype : `${userInfo.user_type}`,
      }
      this.$http
            .post(
              `${ CONSTANTS.MIGRATION_API_URL}/getAllScansForDropDown`,obj).then(result => {
                if (result.body.returnmsg === "Successful") {
                 this.allStatus=result.body.returnvalue;
                 
                }else{
                  this.allStatus=[];
                }
              }).catch(ex => {
              console.log("error", ex);
            });
      },
  
      formatDate: function(date) {
            var d = new Date(date),
                month = "" + (d.getMonth() + 1),
                day = "" + d.getDate(),
                year = d.getFullYear();
            if (month.length < 2) month = "0" + month;
            if (day.length < 2) day = "0" + day;
            return [year, month, day].join("-")
        },
  
        downloadUrl(status, hub, auditID)
        {
  
            console.log(status, 'stattttttssssss', hub);
              var userdata = localStorage.getItem("userData");
              var userInfo = JSON.parse(userdata)
              let obj = ''
                if (status === 'main-dashobard') {
                    // obj = {
                    //   hubid: this.selectedhub && this.selectedhub.key ? this.selectedhub.key.toString() : userInfo.user_type === 1 ? '' : this.selectedhub.key = userInfo.hub_id.toString(),
                    //   date: this.selectFromDate!=null ? this.selectFromDate : null,
                    //   pageno:this.pageNum ? this.pageNum :1,
                    //   limit: 10,
                     
                    // }
                    if (this.selectedhub && this.selectedhub.key) {
                      this.selectedhub = this.selectedhub.key.toString();
                    } else if (userInfo.user_type === 1) {
                      this.selectedhub = '';
                    } else {
                      this.selectedhub = '';
                    }
                    if (this.selectFromDate!=null) {
                      this.selectFromDate = this.selectFromDate
                    } else {
                      this.selectFromDate = null
                    }
  
  
                    let obj = `hubid=${this.selectedhub}&&date=${this.selectFromDate}&&pageno=${this.pageNum}&&limit=10`;
                                  
                } 
  
                if (status === 'hub-details') {
                  // obj = {
                  //     hubid: this.hub_id
                  // };
                  obj = `hubid=${hub}`;
                }
  
                if (status === 'audit-details') {
                  // obj = {
                  //   hubid: this.hub_id,
                  //   audit_id: this.audit_id
                  // };
                  obj = `hubid=${hub}&&audit_id=${auditID}`;
                }
  
                if (hub === 'table-data') {
                  obj = `empi_id=${status.emp_id}&&sysusermasterid=${userInfo.sysusermasterid}`;
                }
                
  
                // obj.sysusermasterid=`${userInfo.sysusermasterid}`,
  // console.log(obj, 'objjjjj11122244446555')
  // return false;
  
  
      this.$http.get(`${CONSTANTS.MIGRATION_API_URL}/getCsvForAllAuditDetails?${obj}`).then(result => {
                if (result.body.msg === "success") {
                 this.loadurl=result.body.location;
                 window.open(this.loadurl, '_blank');
                }else{
                  this.loadurl=[];
                }
              }).catch(ex => {
              console.log("error", ex);
            });
          }, 
  
  
          endAuditScanned() {
            try {
            this.activeAndAuditScannedBtn = true;
            this.closeAuditScanned();
            this.dashboardList(this.pageNum);
           
            // return false;
            var userdata = localStorage.getItem("userData");
            var userInfo = JSON.parse(userdata);
            const obj={
              sysusermasterid:`${userInfo.sysusermasterid}`,
              audit_id : this.auditID
              // usertype : `${userInfo.user_type}`,
            }
            this.$http
                  .post(
                    `${ CONSTANTS.MIGRATION_API_URL}/endHubAudit`,obj).then(result => {
                      if (result.body.returnmsg === "Successful") {
      //                   Object.keys(this.secondLevelCollapseVisible).forEach(key => {
      //   this.$set(this.secondLevelCollapseVisible, key, false);
      // });
      Object.keys(this.secondLevelCollapseVisible).forEach(key => {
    // Close all collapses except the one that was clicked
    if (key !== collapseKey) {
      this.$set(this.secondLevelCollapseVisible, key, false);
    }
  });
  
                      
                      }else{
      //                   Object.keys(this.secondLevelCollapseVisible).forEach(key => {
      //   this.$set(this.secondLevelCollapseVisible, key, false);
      // });
      Object.keys(this.secondLevelCollapseVisible).forEach(key => {
    // Close all collapses except the one that was clicked
    if (key !== collapseKey) {
      this.$set(this.secondLevelCollapseVisible, key, false);
    }
  });
  
                        this.allStatus=[];
                      }
                    }).catch(ex => {
      //                 Object.keys(this.secondLevelCollapseVisible).forEach(key => {
      //   this.$set(this.secondLevelCollapseVisible, key, false);
      // });
      Object.keys(this.secondLevelCollapseVisible).forEach(key => {
    // Close all collapses except the one that was clicked
    if (key !== collapseKey) {
      this.$set(this.secondLevelCollapseVisible, key, false);
    }
  });
  
                    console.log("error", ex);
                  });
            } catch (error) {
      //         Object.keys(this.secondLevelCollapseVisible).forEach(key => {
      //   this.$set(this.secondLevelCollapseVisible, key, false);
      // });
      Object.keys(this.secondLevelCollapseVisible).forEach(key => {
    // Close all collapses except the one that was clicked
    if (key !== collapseKey) {
      this.$set(this.secondLevelCollapseVisible, key, false);
    }
  });
  
              console.log("error", error);
            }
            
          },
          
          transporterMasterLog(auditid) {   
      
        // Show dispute confirmation modal
        this.auditID=auditid;
        
        this.$refs.transporterLogModal.show();
      },
      closeAuditScanned() {
        this.$refs.transporterLogModal.hide();
      }
  }
  };
  </script>
  <style scoped>
  .custom-header-outer {
    padding: 15px;
    border: 1px solid #000;
    /* background-color: #fff; */
  }
  .custom-inner-outer {
    padding: 20px;
  }
  .card-header {
    background-color: #20a8d8 !important
  
  }
  .card-body {
    padding: 0px !important;
  }
  .custom-card-outer {
    background-color: #fff;
    padding: 20px;
  }
  .custom-inner-before-table .card-header{
    background-color: antiquewhite !important;
    /* padding: 20px; */
  }
  .custom-padding-card {
    padding: 10px !important;
    background-color: darkgray !important;
  }
  .custom-end-audit-scanning {
    padding: 10px !important;
    background-color: aquamarine;
  }
  .table-card-outer {
    padding: 10px;
    background-color: darkgray;
    /* border-radius: 1px solid #000; */
  }
  
  .toggle-icon {
    cursor: pointer; /* Make icon visually clickable */
    transition: transform 0.2s ease, color 0.3s ease; /* Optional smooth transition */
  }
  
  .toggle-icon:hover {
    transform: scale(1.1); /* Slightly enlarge the icon on hover */
    color: #007bff; /* Optionally change the color on hover */
  }
  .custom-basealign {
    align-items: baseline;
  }
  .custom-outer-card {
    padding-left: 30px;
    padding-right: 30px;
  }
  .custom-bg-btn {
    background-color: chartreuse;
  }
  .custom-card-border {
    border: none !important;
  }
  .custom-align-btn {
  text-align: end;
  }
  .highlight-row {
    background-color: yellow; /* Highlight color */
  }
  .highlight-red {
    background-color: red; /* Highlight color for non-'ZoneInScan' box statuses */
  }
  .table-responsive {
    max-width: 100%;  /* Make the table container take the full width */
    overflow-x: auto; /* Enable horizontal scroll when needed */
  }
  
  .text-center {
    text-align: center;
  }
  
  .fa-spinner {
    font-size: 2rem;
    color: darkgray;
  }
  .custom-download-align {
    text-align: end;
  }
  .loader-overlay {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    background-color: rgba(255, 255, 255, 0.7); /* semi-transparent background */
    z-index: 9999; /* Ensure it's above all other content */
  }
  
  </style>